import { ReactNode } from 'react';

export type MisContainerPropsType = {
  containerClassName?: string;
  title?: string;
  headerClassName?: string;
  body?: ReactNode;
  bodyClassName?: string;
  footer?: ReactNode;
  footerClassName?: string;
};
export type MisContainerType = React.FunctionComponent<MisContainerPropsType>;

export const MisContainer: MisContainerType = (props) => {
  return (
    <>
      {props.body}
      {props.footer}
    </>
  );
};
